export default 'Simulez vos aides rénovation en 60 sec : MaPrimeRénov’, primes CEE, éco-PTZ, TVA 5,5 % cumulés. Réseau artisans RGE, aucune avance demandée.';
